  document.addEventListener('DOMContentLoaded', function () {
    const splideElements = document.querySelectorAll('.splide');
    splideElements.forEach((splideElement) => {
      new Splide(splideElement, {
        type: 'slide',
        perPage: 1,
        gap: '1rem',
        rewind: true,
        pagination: false,
      }).mount();
    });
  });
